const fr = {
  brand: "E2 Care",
  tagline: "Soins calmes et connectés.",
  nav_dashboard: "Tableau de bord",
  nav_residents: "Patients",
  nav_patients: "Patients",
  nav_rooms: "Chambres",
  nav_devices: "Appareils",
  nav_events: "Événements",
  nav_alerts: "Alertes",
  nav_users: "Équipe",
  nav_settings: "Paramètres",
  nav_admin: "Administration",
  nav_signout: "Se déconnecter",
  topbar_search_placeholder: "Rechercher patients, chambres, appareils…",
  admin_super_only: "Seuls les super-administrateurs peuvent gérer les organisations.",
  admin_admin_only: "Seuls les administrateurs peuvent accéder à cette page.",
  admin_tab_orgs: "Organisations",
  admin_tab_users: "Utilisateurs",
  admin_tab_patients: "Patients",
  admin_tab_rooms: "Chambres",
  admin_tab_buildings: "Bâtiments",
  admin_tab_devices: "Appareils",
  admin_tab_alerts: "Alertes",
  admin_tab_qa: "Outils de test",
  admin_delete: "Supprimer",
  admin_no_orgs_yet: "Aucune organisation pour le moment.",
  admin_field_name: "Nom",
  admin_field_email: "E-mail",
  admin_field_phone: "Téléphone",
  admin_field_password: "Mot de passe",
  admin_field_role: "Rôle",
  admin_field_type: "Type",
  admin_field_timezone: "Fuseau horaire",
  admin_field_address: "Adresse",
  admin_field_status: "Statut",
  admin_field_organization: "Organisation",
  admin_password_keep: "Laisser vide pour conserver",
  admin_field_birth_date: "Date de naissance",
  admin_field_room: "Chambre",
  admin_field_room_none: "Non assigné",
  admin_field_photo: "URL de la photo",
  admin_field_photo_hint: "Collez une URL publique — téléversement complet en v2.",
  admin_field_notes: "Notes du soignant",
  admin_field_emergency_contact: "Contact d’urgence principal",
  admin_field_ec_name: "Nom",
  admin_field_ec_phone: "Téléphone",
  admin_field_ec_relationship: "Lien",
  admin_field_mac: "Adresse MAC",
  admin_field_firmware: "Micrologiciel",
  admin_field_assignment: "Affecté à",
  admin_field_assigned_room: "Chambre affectée",
  admin_field_assigned_patient: "Patient affecté",
  admin_field_assigned_hint: "Facultatif. Capteurs → chambre ; bracelets → patient.",
  admin_field_sensor_target: "Monté sur",
  admin_field_sensor_target_hint: "Indique au système si ce capteur surveille une porte ou une fenêtre.",
  sensor_target_door: "Porte",
  sensor_target_window: "Fenêtre",
  sensor_target_unset: "Non configuré",
  admin_field_sensor_label: "Nom du capteur",
  admin_field_sensor_label_hint: "Nom convivial affiché dans les alertes et les événements — p. ex. « Porte d’entrée », « Fenêtre de la salle de bain ».",
  admin_field_building: "Bâtiment",
  admin_field_building_required: "Une chambre doit appartenir à un bâtiment.",
  room_openings: "Ouvertures",
  room_no_openings: "Aucun capteur de porte ou de fenêtre installé dans cette chambre.",
  room_openings_summary: "{doors} {doorsLabel} · {windows} {windowsLabel}",
  opening_last_event: "Dernier changement",
  admin_field_description: "Description",
  admin_field_severity: "Gravité",
  admin_field_patient: "Patient",
  admin_field_device: "Appareil",
  admin_field_message: "Message",
  admin_orgs_title: "Organisations",
  admin_orgs_sub: "Créer, modifier et archiver les locataires d’E2 Care.",
  admin_orgs_count: "organisations",
  admin_org_new: "Nouvelle organisation",
  admin_org_new_title: "Nouvelle organisation",
  admin_org_edit_title: "Modifier l’organisation",
  admin_org_created: "Organisation créée.",
  admin_org_updated: "Organisation mise à jour.",
  admin_org_deleted: "Organisation archivée.",
  admin_org_delete_title: "Archiver l’organisation ?",
  admin_org_delete_confirm: "« {name} » sera masquée des listes.",
  admin_users_title: "Utilisateurs",
  admin_users_sub_super: "Gérer chaque compte utilisateur sur tous les locataires.",
  admin_users_sub_org: "Gérer les comptes utilisateurs de {org}.",
  admin_user_new: "Nouvel utilisateur",
  admin_user_new_title: "Nouvel utilisateur",
  admin_user_edit_title: "Modifier l’utilisateur",
  admin_user_created: "Utilisateur créé.",
  admin_user_updated: "Utilisateur mis à jour.",
  admin_user_deleted: "Utilisateur archivé.",
  admin_user_delete_title: "Archiver l’utilisateur ?",
  admin_user_delete_confirm: "« {name} » perdra l’accès.",
  admin_user_memberships: "Adhésions aux organisations",
  admin_patients_title: "Patients",
  admin_patients_sub_super: "Gérer tous les dossiers patients sur tous les locataires.",
  admin_patients_sub_org: "Gérer les dossiers patients dans {org}.",
  admin_patient_new: "Nouveau patient",
  admin_patient_new_title: "Nouveau patient",
  admin_patient_edit_title: "Modifier le patient",
  admin_patient_created: "Patient créé.",
  admin_patient_updated: "Patient mis à jour.",
  admin_patient_deleted: "Patient archivé.",
  admin_patient_delete_title: "Archiver le patient ?",
  admin_patient_delete_confirm: "« {name} » sera masqué des listes.",
  admin_rooms_title: "Chambres",
  admin_rooms_sub_super: "Configurer les chambres sur tous les locataires.",
  admin_rooms_sub_org: "Configurer les chambres dans {org}.",
  admin_room_new: "Nouvelle chambre",
  admin_room_new_title: "Nouvelle chambre",
  admin_room_edit_title: "Modifier la chambre",
  admin_room_created: "Chambre créée.",
  admin_room_updated: "Chambre mise à jour.",
  admin_room_deleted: "Chambre archivée.",
  admin_room_delete_title: "Archiver la chambre ?",
  admin_room_delete_confirm: "« {name} » sera masquée.",
  admin_devices_title: "Appareils",
  admin_devices_sub_super: "Provisionner les appareils Moko sur tous les locataires.",
  admin_devices_sub_org: "Provisionner les appareils Moko dans {org}.",
  admin_device_new: "Nouvel appareil",
  admin_device_new_title: "Nouvel appareil",
  admin_device_edit_title: "Modifier l’appareil",
  admin_device_created: "Appareil créé.",
  admin_device_updated: "Appareil mis à jour.",
  admin_device_deleted: "Appareil archivé.",
  admin_device_delete_title: "Archiver l’appareil ?",
  admin_device_delete_confirm: "L’appareil {mac} sera masqué.",
  admin_buildings_title: "Bâtiments",
  admin_buildings_sub_super: "Regrouper les chambres par bâtiment / aile sur tous les locataires.",
  admin_buildings_sub_org: "Regrouper les chambres par bâtiment / aile dans {org}.",
  admin_building_new: "Nouveau bâtiment",
  admin_building_new_title: "Nouveau bâtiment",
  admin_building_edit_title: "Modifier le bâtiment",
  admin_building_created: "Bâtiment créé.",
  admin_building_updated: "Bâtiment mis à jour.",
  admin_building_deleted: "Bâtiment archivé.",
  admin_building_delete_title: "Archiver le bâtiment ?",
  admin_building_delete_confirm: "« {name} » sera masqué.",
  admin_qa_title: "Outils de test",
  admin_qa_sub: "Injecter événements / alertes pour tester sans matériel Moko réel.",
  admin_qa_event_title: "Injecter un événement test",
  admin_qa_event_sub: "Simule un webhook Moko.",
  admin_qa_alert_title: "Injecter une alerte test",
  admin_qa_alert_sub: "Saute la couche événement et écrit une alerte directement.",
  admin_qa_inject_event: "Injecter un événement",
  admin_qa_inject_alert: "Injecter une alerte",
  admin_qa_event_done: "Événement injecté.",
  admin_qa_alert_done: "Alerte injectée.",
  admin_qa_disclaimer: "Ces endpoints doivent être désactivés en production.",
  admin_alerts_title: "Politique d’alertes",
  admin_alerts_sub: "Règles d’alerte pour l’ensemble de {org}. Appliquées à chaque patient de ce locataire.",
  admin_alerts_quiet_title: "Heures calmes",
  admin_alerts_quiet_desc: "Définissez quand cette organisation est en « mode nuit ». Utile pour acheminer les alertes non critiques plus discrètement.",
  admin_alerts_quiet_hint: "Les heures sont interprétées dans le fuseau horaire local de l’organisation. La plage peut passer minuit (p. ex. 22:00 → 06:00).",
  admin_alerts_night_start: "Début de nuit",
  admin_alerts_night_end: "Fin de nuit",
  admin_alerts_load_failed: "Charger la politique d’alertes",
  admin_alerts_save_failed: "Enregistrer la politique d’alertes",
  admin_alerts_saved: "Politique d’alertes enregistrée.",
  admin_alerts_clear_title: "Effacer les alertes actives",
  admin_alerts_clear_desc: "Accusez réception de toutes les alertes ouvertes de cette organisation en un clic.",
  admin_alerts_clear_hint: "Utile après un exercice planifié ou un capteur mal configuré ayant produit une vague de faux positifs. Les alertes acquittées restent dans l’historique.",
  admin_alerts_ack_all_button: "Tout acquitter",
  admin_alerts_ack_all_title: "Acquitter toutes les alertes actives ?",
  admin_alerts_ack_all_confirm: "Cela marquera comme acquittée chaque alerte ouverte dans {org}. Cette action est irréversible.",
  admin_alerts_ack_all_done: "{count} alerte(s) acquittée(s).",
  admin_alerts_ack_all_done_generic: "Toutes les alertes actives ont été acquittées.",
  admin_alerts_ack_all_failed: "Acquitter toutes les alertes",
  org_type_nursing_home: "Maison de retraite",
  org_type_assisted_living: "Résidence assistée",
  org_type_hospital: "Hôpital",
  org_type_home_care: "Soins à domicile",
  role_admin: "Administrateur",
  role_caregiver: "Soignant",
  role_family: "Famille",
  status_active: "actif",
  status_inactive: "inactif",
  confirm: "Confirmer",
  sign_in: "Se connecter",
  signed_in: "Connecté",
  sign_up: "S’inscrire",
  email: "E-mail",
  password: "Mot de passe",
  full_name: "Nom complet",
  create_account: "Créer un compte",
  no_account: "Pas encore de compte ?",
  have_account: "Vous avez déjà un compte ?",
  login_welcome: "Bon retour",
  login_sub: "Connectez-vous pour continuer à surveiller vos résidents.",
  register_welcome: "Rejoignez E2 Care",
  register_sub: "Créez votre espace de travail en moins d’une minute.",
  total_residents: "Patients",
  active_devices: "Appareils actifs",
  open_alerts: "Alertes ouvertes",
  offline_gateways: "Appareils hors ligne",
  falls_7d: "Chutes (7j)",
  sos_7d: "SOS (7j)",
  low_battery: "Batterie faible",
  critical_residents: "Critiques",
  status_ok: "Tout va bien",
  status_warning: "Attention",
  status_critical: "Critique",
  status_online: "En ligne",
  status_offline: "Hors ligne",
  search: "Rechercher",
  filter: "Filtrer",
  all: "Tous",
  refresh: "Actualiser",
  loading: "Chargement…",
  no_results: "Rien pour le moment.",
  view_profile: "Voir le profil",
  showing_n_of_m: "Affichage de {n} sur {m}",
  load_more: "Charger plus",
  auto_refresh: "En direct · auto-actualisation",
  auto_refresh_paused: "En pause (charger plus actif)",
  updated_just_now: "Mis à jour à l’instant",
  updated_n_sec_ago: "Mis à jour il y a {n}s",
  updated_n_min_ago: "Mis à jour il y a {n}m",
  acknowledge: "Acquitter",
  acknowledged: "Acquitté",
  ack_all: "Tout acquitter",
  ack_all_confirm: "Acquitter les {count} alerte(s) active(s) ?",
  ack_all_running: "Acquittement…",
  ack_all_done: "{count} alerte(s) acquittée(s).",
  ack_all_partial: "{ok} acquittée(s) · {fail} échec(s).",
  last_seen: "Vu pour la dernière fois",
  battery: "Batterie",
  signal: "Signal",
  firmware: "Micrologiciel",
  room: "Apt / Chambre",
  age: "Âge",
  emergency_contact: "Contact d’urgence",
  notes: "Notes",
  assigned_devices: "Appareils affectés",
  recent_events: "Événements récents",
  timeline_24h: "Dernières 24 heures",
  delivery_status: "Statut de livraison",
  acknowledged_by: "Acquitté par",
  dashboard_title: "Aperçu",
  dashboard_sub: "Un aperçu rapide de tout ce qui se passe dans vos résidences.",
  residents_title: "Patients",
  residents_sub: "Les personnes que vous surveillez actuellement.",
  devices_title: "Appareils",
  devices_sub: "Capteurs et bracelets.",
  devices_sub_admin: "Passerelles, capteurs et bracelets.",
  events_title: "Événements en direct",
  events_sub: "Flux chronologique de chaque appareil connecté.",
  alerts_title: "Alertes",
  alerts_sub: "Notifications escaladées à la famille et aux soignants.",
  settings_title: "Paramètres",
  settings_sub: "Vos préférences et règles de notification.",
  users_title: "Équipe",
  users_sub: "Soignants, famille et administrateurs ayant accès.",
  falls_chart_title: "Chutes & SOS — 7 derniers jours",
  recent_alerts_title: "Alertes critiques récentes",
  no_alerts: "Aucune alerte ouverte. Tout le monde est en sécurité.",
  event_fall: "Chute détectée",
  event_sos: "Bouton SOS pressé",
  event_door_open: "Porte ouverte",
  event_door_close: "Porte fermée",
  event_inactivity: "Inactivité prolongée",
  event_low_battery: "Batterie faible",
  event_offline: "Appareil hors ligne",
  event_online: "Appareil de retour en ligne",
  event_heartbeat: "Battement",
  event_button_press: "Bouton pressé",
  device_gateway: "Passerelle Bluetooth",
  device_door_sensor: "Capteur de porte",
  device_bracelet: "Bracelet",
  device_unknown: "Appareil inconnu",
  language: "Langue",
  notifications: "Notifications",
  quiet_hours: "Heures calmes",
  escalation: "Politique d’escalade",
  just_now: "à l’instant",
  rel_prefix: "il y a",
  min_ago: "min",
  h_ago: "h",
  d_ago: "j",
  demo_hint: "Compte démo : admin@e2care.lv / Care2024!",
  open_menu: "Ouvrir le menu",
  close_menu: "Fermer le menu",
  care_team: "Équipe soignante",
  family_members: "Famille",
  no_caregivers: "Aucun soignant assigné pour le moment.",
  no_family: "Aucun membre de la famille lié pour le moment.",
  add_caregiver: "Ajouter un soignant",
  add_family: "Ajouter un membre de la famille",
  select_user: "Sélectionnez un utilisateur…",
  cancel: "Annuler",
  add: "Ajouter",
  remove: "Retirer",
  save: "Enregistrer",
  relationship: "Lien de parenté",
  relationship_son: "Fils",
  relationship_daughter: "Fille",
  relationship_spouse: "Conjoint",
  relationship_other: "Autre",
  notify_via: "Notifier via",
  call_contact: "Appeler",
  view_resident: "Ouvrir le profil",
  address: "Adresse",
  admin_only_section: "Outils admin",
  rooms_title: "Chambres",
  rooms_sub: "Chaque chambre supervisée — patients, appareils et état actuel.",
  room_name: "Chambre",
  room_type: "Type",
  room_type_private_room: "Chambre privée",
  room_type_shared_room: "Chambre partagée",
  room_type_apartment: "Appartement",
  room_type_corridor: "Couloir",
  room_type_common_area: "Espace commun",
  room_floor: "Étage",
  room_state: "État actuel",
  door: "Porte",
  window: "Fenêtre",
  door_open_state: "Ouverte",
  door_closed_state: "Fermée",
  door_unknown_state: "Inconnue",
  room_no_devices: "Aucun appareil dans cette chambre pour le moment.",
  room_no_patients: "Aucun patient affecté à cette chambre pour le moment.",
  room_patients: "Patients dans la chambre",
  room_devices: "Appareils dans la chambre",
  room_activity: "Chronologie d’activité",
  rooms_filter_all_types: "Tous les types",
  widget_active_alerts: "Alertes actives",
  widget_active_alerts_sub: "Critiques, non résolues et acquittées",
  widget_patients_status: "État des patients",
  widget_devices_health: "État des appareils",
  widget_room_activity: "Activité des chambres",
  widget_recent_events: "Flux d’événements en direct",
  widget_connectivity: "Connectivité",
  metric_critical: "Critique",
  metric_unresolved: "Non résolu",
  metric_acknowledged_count: "Acquittés",
  metric_total: "Total",
  metric_active: "Actifs",
  metric_online: "En ligne",
  metric_offline: "Hors ligne",
  metric_ota_pending: "OTA en attente",
  metric_battery_warn: "Batterie faible",
  metric_doors_open: "Portes ouvertes",
  metric_windows_open: "Fenêtres ouvertes",
  metric_signal_avg: "Signal moyen",
  metric_last_comm: "Dernière comm",
  metric_packets: "Paquets / h",
  view_all: "Voir tout",
  status_new: "Nouveau",
  status_acknowledged: "Acquitté",
  status_resolved: "Résolu",
  status_resolved_local: "Résolu (local)",
  resolve: "Résoudre",
  add_note: "Ajouter une note",
  save_note: "Enregistrer la note",
  resolve_local_badge: "cet appareil uniquement",
  resolve_local_hint: "Marque l’alerte comme résolue uniquement dans votre navigateur. Le serveur et les autres membres de l’équipe la voient toujours comme ouverte.",
  note_placeholder: "Ajoutez du contexte pour l’équipe…",
  notes_count: "{n} note(s)",
  device_detail: "Détail de l’appareil",
  device_diagnostics: "Diagnostics",
  device_firmware_history: "Historique du micrologiciel",
  device_ota_config: "Configuration OTA",
  device_ota_status: "Statut OTA",
  device_signal: "Qualité du signal",
  device_mac: "Adresse MAC",
  device_serial: "Numéro de série",
  fall_sensitivity: "Sensibilité aux chutes",
  transmission_interval: "Intervalle de transmission",
  low_battery_threshold: "Seuil de batterie faible",
  ota_idle: "Inactif",
  ota_pending: "En attente",
  ota_deploying: "Déploiement",
  ota_failed: "Échec",
  events_filter_severity: "Gravité",
  events_filter_room: "Chambre",
  events_filter_patient: "Patient",
  events_filter_device: "Appareil",
  severity_info: "Info",
  severity_warning: "Avertissement",
  severity_critical: "Critique",
  telegram_title: "Alertes Telegram",
  telegram_desc: "Recevez des alertes Telegram pour les résidents qui vous sont assignés.",
  telegram_connect: "Connecter Telegram",
  telegram_connected: "Telegram connecté",
  telegram_connected_as: "Connecté à Telegram en tant que {name}",
  telegram_connect_success: "Telegram connecté avec succès",
  telegram_connect_error: "Impossible de connecter Telegram. Veuillez réessayer.",
  telegram_missing_bot: "Bot Telegram non configuré. Définissez REACT_APP_TELEGRAM_BOT dans le fichier env.",
  telegram_disconnect: "Déconnecter",
  telegram_disconnect_success: "Telegram déconnecté.",
  telegram_disconnect_error: "Impossible de déconnecter Telegram. Veuillez réessayer.",
  telegram_already_linked: "Ce compte Telegram est déjà lié à un autre utilisateur e2-care.",
  telegram_switch_q: "Utiliser un autre compte Telegram ?",
  telegram_switch_intro: "Telegram mémorise le compte connecté sur tous les sites web. Pour en utiliser un autre :",
  telegram_switch_step1: "Ouvrez Telegram Web et déconnectez-vous de votre compte actuel.",
  telegram_switch_step2: "Revenez ici et rechargez le bouton ci-dessous, puis connectez-vous avec l’autre compte.",
  telegram_open_web: "Ouvrir Telegram Web",
  telegram_reload_widget: "Je me suis déconnecté — recharger le bouton",
  lang_autodetected_toast: "Langue détectée : {language}. Vous pouvez la changer dans les Paramètres.",
  admin_view_active: "Actifs",
  admin_view_archived: "Archivés",
  admin_restore: "Restaurer",
  admin_restored: "Restauré.",
  admin_hard_delete: "Supprimer définitivement",
  admin_hard_delete_title: "Supprimer définitivement ?",
  admin_hard_delete_confirm: "« {name} » sera définitivement supprimé de la base de données. Cette action est irréversible.",
  admin_hard_deleted: "Définitivement supprimé.",
  admin_no_archived: "Aucun élément archivé.",
  language_desc: "Utilisée pour l’interface de l’application et vos notifications Telegram + push.",
  language_saved: "Langue mise à jour.",
  language_error: "Impossible de mettre à jour la langue. Veuillez réessayer.",
  admin_field_language: "Langue",
  edit: "Modifier",
  generic_error: "Une erreur s’est produite. Veuillez réessayer.",
  caregiver_added: "Soignant ajouté.",
  caregiver_removed: "Soignant retiré.",
  family_added: "Membre de la famille ajouté.",
  family_removed: "Membre de la famille retiré.",
  menu: "Menu",
  dl_companion_app: "Application compagnon",
  dl_hero_title: "E2 Care pour Android",
  dl_hero_sub: "Installez l’application compagnon sur un téléphone équipé Moko pour relayer les alertes, configurer les appareils et rester connecté à votre équipe de soins — même lorsque le tableau de bord est fermé.",
  dl_android_apk: "APK Android",
  dl_version_loading: "chargement de la version…",
  dl_released: "Publié le {date}",
  dl_download_apk: "Télécharger l’APK",
  dl_unavailable: "Indisponible",
  dl_preparing: "Préparation…",
  dl_manifest_error: "Impossible de charger le manifeste. Essayez d’actualiser — si le problème persiste, le serveur de build est peut-être en cours de redéploiement.",
  dl_whats_new: "Nouveautés",
  dl_installing_title: "Installation sur votre téléphone",
  dl_step1: "Appuyez sur « Télécharger l’APK » ci-dessus. Votre navigateur peut avertir que les fichiers APK peuvent endommager votre appareil — cet avertissement est normal pour tout installateur téléchargé hors du Play Store.",
  dl_step2: "Ouvrez le fichier téléchargé. Android vous demandera d’autoriser les installations depuis ce navigateur la première fois — activez l’autorisation, puis revenez.",
  dl_step3: "Appuyez sur « Installer », puis sur « Ouvrir » une fois terminé.",
  dl_step4: "Connectez-vous avec vos identifiants E2 Care.",
  dl_iphone_note: "La version iPhone arrivera plus tard. Pour l’instant, veuillez utiliser le tableau de bord web.",
  dl_back_to_dashboard: "Retour au tableau de bord",
  dl_android_min: "Android {version}+",
  admin_device_org_change_hint: "Changer d’organisation efface l’affectation actuelle de chambre et de patient.",
  admin_view_full: "Liste complète",
  device_filter_assignment: "Affectation",
  device_filter_patient: "Affecté à un patient",
  device_filter_room: "Affecté à une chambre",
  device_filter_unassigned: "Non affecté",
  admin_all_orgs: "Toutes les organisations",
  pagination_prev: "Précédent",
  pagination_next: "Suivant",
  pagination_per_page: "Par page",
  pagination_page_of: "Page {page} sur {pages}",
  pagination_total: "{total} au total",
  event_charging: "Charge démarrée",
  event_sos_cancel: "SOS annulé",
  event_call: "Appel SOS",
  device_personal_alarm: "Alarme personnelle",
  device_charging: "En charge",
  device_location: "Localisation",
  device_current_location: "Position actuelle",
  device_no_location: "Aucune position signalée pour l'instant.",
  device_location_source: "Source",
  device_location_updated: "Mis à jour",
  device_track_1h: "1h",
  device_track_24h: "24h",
  device_track_7d: "7j",
  device_track_last: "Dernière position",
  device_located: "Localisé",
  map_sos: "Alerte SOS",
  map_fall: "Chute détectée",
  map_current: "Position actuelle",
  alert_timeline: "Chronologie de l'alerte",
  alert_trigger: "Déclencheur",
  alert_calls: "Appels",
  alert_view_timeline: "Voir la chronologie",
  alert_no_deliveries: "Aucune notification envoyée pour l'instant.",
  alert_cancelled_on_device: "Le SOS a été annulé sur l'appareil — l'alerte reste ouverte jusqu'à ce qu'un soignant la résolve.",
  call_answered: "Répondu",
  call_missed: "Manqué",
  reopen: "Rouvrir",
  reopened: "Alerte rouverte",
  live: "En direct",
  nav_home: "Accueil",
  family_home_kicker: "Vue famille",
  family_home_title: "Vos proches",
  family_greeting: "Bonjour",
  family_home_sub: "Un aperçu apaisant de l'état de chacun.",
  family_status_ok: "va bien",
  family_status_attention: "nécessite une attention",
  family_all_calm: "Tout est calme pour le moment.",
  family_attention_sub: "Prenons de ses nouvelles — détails ci-dessous.",
  family_last_seen: "vu pour la dernière fois",
  family_latest_alert: "Dernière alerte",
  family_no_alerts: "Aucune alerte récente — tout va bien.",
  family_view_details: "Voir les détails",
  family_no_device: "Aucune alarme personnelle liée pour l'instant.",
  status_never_reported: "Jamais signalé",
  mv_title: "Mouvement",
  mv_sub: "De {n} capteur(s) de mouvement · fenêtres de 5 minutes",
  mvo_title: "Les mouvements en un coup d'œil",
  mvs_moving: "{name} est debout et en mouvement",
  mvs_moving_sub: "A bougé {when}",
  mvs_rest: "{name} se repose",
  mvs_rest_sub: "Dernier mouvement {when}",
  mvs_rest_sub_none: "Aucun mouvement ces 30 derniers jours",
  mvs_quiet: "{name} est calme depuis plus longtemps que d'habitude",
  mvs_quiet_sub: "Aucun mouvement depuis {dur}. Un petit appel peut valoir la peine.",
  mvs_short_quiet: "Calme prolongé",
  mvs_room_moving: "Quelqu'un bouge dans {name}",
  mvs_room_rest: "{name} est calme",
  mvs_room_quiet: "Aucun mouvement dans {name} depuis plus longtemps que d'habitude",
  mvs_sensor: "Le capteur de mouvement n'envoie rien",
  mvs_sensor_sub: "Cela concerne le capteur, pas {name}. Dernier signal {when}.",
  mvs_nodata: "Pas encore de données de mouvement",
  mvs_nodata_sub: "Le capteur de mouvement n'a encore rien envoyé.",
  mvd_title: "Dernières 24 heures",
  mvd_moving: "En mouvement",
  mvd_resting: "Au repos",
  mvd_nosignal: "Pas de signal",
  mvd_night: "Nuit",
  mvd_now: "Maintenant",
  mvn_title: "7 dernières nuits",
  mvn_last_night: "La nuit dernière",
  mvn_last_short: "Hier",
  mvn_calm: "Calme",
  mvn_restless: "Agitée",
  mvn_still: "Très peu de mouvement",
  mvn_silent: "Capteur muet",
  mvn_nodata: "Pas de données",
  mvn_s_calm_none: "Nuit calme, aucun mouvement entre {from} et {to}.",
  mvn_s_calm_once: "Nuit calme, un seul lever vers {at}.",
  mvn_s_calm_many: "Nuit calme, {n} levers, le premier vers {first}, le dernier vers {last}.",
  mvn_s_restless: "Nuit agitée, {n} levers entre {first} et {last}.",
  mvn_s_still: "Nuit avec très peu de mouvement, moins que d'habitude. Plus long repos {dur}.",
  mvn_s_still_moved: "Nuit avec très peu de mouvement, seulement vers {at}. Plus long repos {dur}.",
  mvn_s_silent: "Le capteur est resté presque muet, on ne peut pas dire comment s'est passée la nuit.",
  mvn_s_nodata: "Pas de données de mouvement pour cette nuit.",
  mv_state_moving: "En mouvement",
  mv_state_still: "Au repos",
  mv_state_inactive: "Inactif",
  mv_state_silent: "Capteur muet",
  mv_state_never: "Jamais signalé",
  mv_state_nodata: "Pas encore de données",
  mv_state_no_sensor: "Aucun capteur de mouvement",
  mv_last_movement: "Dernier mouvement",
  mv_last_sample: "Dernier signal du capteur",
  mv_none_in_retention: "Aucun sur les 30 derniers jours",
  mv_silent_hint: "Aucun échantillon depuis plus de {min} min : vérifiez le capteur ou sa passerelle. C'est une panne d'appareil, pas une immobilité.",
  mv_inactive_hint: "Aucun mouvement depuis plus de {min} min alors que le capteur émet toujours.",
  mv_history: "Historique des mouvements",
  mv_history_empty: "Pas encore de données de mouvement sur cette période.",
  mv_not_reporting: "N'émet pas",
  mv_no_movement: "Aucun mouvement",
  mv_detections: "détections de mouvement",
  mv_legend_motion: "Détections de mouvement",
  mv_legend_gap: "N'émet pas",
  mv_retention_note: "Historique conservé 30 jours",
  mv_strip_title: "Mouvement en direct",
  mv_strip_sub: "{n} capteur(s) de mouvement",
  mv_unassigned: "Capteur non attribué",
  admin_alerts_timezone: "Fuseau horaire de l'organisation",
  admin_alerts_timezone_invalid: "Choisissez un fuseau horaire IANA valide.",
  admin_alerts_night_wrap_hint: "La nuit va de {start} à {end} le lendemain matin ({tz}), c'est-à-dire après {start} ou avant {end}.",
  admin_alerts_night_same_day_hint: "La nuit va de {start} à {end} le même jour ({tz}).",
  admin_alerts_night_equal: "Le début et la fin ne peuvent pas être identiques.",
  admin_alerts_inactivity_label: "Seuil d'inactivité",
  admin_alerts_inactivity_question: "Cette personne a-t-elle bougé ? Minutes sans mouvement avant que cela devienne une alerte.",
  admin_alerts_silence_label: "Seuil de silence de l'appareil",
  admin_alerts_silence_question: "Ce capteur communique-t-il encore ? Minutes sans aucun échantillon avant de le considérer comme une panne d'appareil plutôt qu'un résident inactif.",
  admin_alerts_minutes: "minutes",
  admin_alerts_threshold_invalid: "Saisissez un nombre entier supérieur à 0.",
  admin_alerts_thresholds_provisional: "Les valeurs initiales (180 / 30 min) n'ont pas encore été ajustées : adaptez-les à vos résidents.",
  admin_tab_gateways: "Passerelles",
  gw_title: "Passerelles",
  gw_status_deactivated: "Désactivée",
  gw_scope_pending: "Les passerelles de votre organisation apparaîtront ici dès que la mise à jour du backend sera en ligne.",
  gw_none_for_org: "Aucune passerelle n'est encore affectée à cette organisation.",
  gw_col_room: "Pièce",
  gw_unassigned: "Non affectée",
  gw_never: "Jamais",
  gw_edit_title: "Modifier la passerelle",
  gw_new_title: "Nouvelle passerelle",
  gw_super_field: "Seul un super-admin peut modifier ce champ",
  gw_mac_invalid: "Saisissez 12 caractères hexadécimaux, ex. AA:BB:CC:DD:EE:FF",
  gw_hw_type: "Type de matériel",
  gw_notes: "Notes",
  gw_manage_sub: "Hubs BLE qui relaient les capteurs : état, organisation et pièce. Une passerelle muette rend muets tous les capteurs derrière elle.",
  gw_filter_all: "Toutes les organisations",
  gw_new: "Nouvelle passerelle",
  gw_col_assignment: "Organisation · Pièce",
  gw_backend_pending: "Cela nécessite la mise à jour du backend, pas encore déployée.",
  gw_save_failed: "Enregistrer la passerelle",
  gw_created: "Passerelle créée",
  gw_saved: "Passerelle enregistrée",
  gw_reactivated: "Passerelle réactivée",
  gw_deactivated: "Passerelle désactivée",
  gw_reactivate: "Réactiver",
  gw_deactivate: "Désactiver",
  gw_reactivate_title: "Réactiver {name} ?",
  gw_deactivate_title: "Désactiver {name} ?",
  gw_reactivate_desc: "Elle comptera de nouveau dans l'état et les alertes.",
  gw_deactivate_desc: "Elle ne compte plus dans l'état et les alertes. Son historique est conservé et vous pouvez la réactiver à tout moment.",
  gw_heard_title: "Appareils entendus",
  gw_heard_sub: "Capteurs relayés par cette passerelle ces dernières 24 heures.",
  gw_heard_none: "Aucun appareil entendu ces dernières 24 heures.",
  gw_heard_unknown: "Appareils inconnus entendus",
  gw_msgs_short: "msg",
  gw_avg: "moy.",
  gw_samples_short: "échant.",
  gw_not_found: "Passerelle introuvable ou non visible pour vous.",
  gw_one: "Passerelle",
  gw_manage_link: "Gérer dans Administration",
  gw_rssi_range: "Plage de signal",
  gw_longest_gap: "Plus longue coupure",
  gw_config_push: "Dernier envoi de config",
  gw_sub: "Concentrateurs BLE relayant les données des capteurs. Lecture seule : une passerelle muette rend muets tous les capteurs derrière elle.",
  gw_super_only: "L'état des passerelles est réservé aux super-administrateurs.",
  gw_load_failed: "Charger les passerelles",
  gw_status_reporting: "Émet",
  gw_status_silent: "Muette",
  gw_status_never_seen: "Jamais vue",
  gw_returned: "Revenue après {h} h d'absence (fin {at})",
  gw_count_reporting: "{n} émettent",
  gw_count_silent: "{n} muettes",
  gw_count_never: "{n} jamais vues",
  gw_count_deactivated: "{n} désactivée(s)",
  gw_window: "Obsolète après {h} h sans message",
  gw_col_name: "Passerelle",
  gw_col_status: "État",
  gw_col_msgs: "Messages 24 h",
  gw_col_discard: "Rejetés",
  gw_last_message: "Dernier message",
  gw_devices_seen: "Appareils vus",
  gw_hours_active: "Heures actives",
  gw_unregistered_title: "Émet sans enregistrement",
  gw_unregistered_desc: "Ces identifiants apparaissent dans l'activité des passerelles mais n'ont pas de fiche (p. ex. une unité émettant sous un IMEI). Les totaux des deux sources diffèrent légitimement.",
  nav_reports: "Rapports",
  rep_night_title: "Résumé de la nuit",
  rep_night_desc: "Récapitulatif matinal des mouvements de chaque résident pendant les heures de nuit de l'organisation, et des silences des capteurs.",
  rep_last_night: "La nuit dernière",
  rep_nights_ago: "Il y a {n} nuits",
  rep_policy_fallback: "heures de nuit par défaut (politique indisponible)",
  rep_movement: "Mouvement",
  rep_windows: "{n} fenêtres de 5 min actives",
  rep_no_movement: "Aucun mouvement",
  rep_first_movement: "Premier mouvement",
  rep_longest_still: "Plus longue immobilité",
  rep_silences: "Silences du capteur",
  rep_none: "Aucun",
  rep_coverage: "{pct} % reçu",
  rep_night_note: "Les heures sont dans le fuseau de l'organisation. L'immobilité n'est comptée que lorsque le capteur émet ; les silences au moins égaux au seuil de silence sont listés à part.",
  dh_reporting_title: "Santé de la transmission",
  dh_never_reported_desc: "Enregistré mais n'a jamais émis. Il s'agit d'une mise en service incomplète, pas d'un appareil hors ligne.",
  dh_interval_still: "Intervalle mesuré (au repos)",
  dh_interval_moving: "Intervalle mesuré (en mouvement)",
  dh_interval_samples: "Échantillons de mesure",
  dh_interval_unmeasured: "Pas encore d'intervalle mesuré : le seuil de silence de l'organisation s'applique.",
  dh_interval_note: "Les intervalles sont mesurés à partir des messages reçus, pas de la valeur configurée.",
  rep_dur_h_min: "{h} h {m} min",
  rep_dur_min: "{m} min",
  rep_shared_room: "Chambre partagée — peut inclure les mouvements d'autres personnes",
  rep_no_data_night: "Aucune donnée pour cette nuit — le capteur n'émettait pas (ou n'était pas encore installé).",
  nav_buildings: "Bâtiments",
  imei_label: "IMEI",
  imei_hint: "15 chiffres, imprimés au dos de l'appareil",
  imei_length: "L'IMEI comporte 15 chiffres",
  imei_invalid: "Cet IMEI n'est pas valide. Vérifiez les chiffres",
  imei_resident_note: "L'alarme suit le résident, elle n'est donc pas attribuée à une chambre.",
  imei_online_hint: "L'appareil apparaît en ligne après son premier signal de vie, environ 5 minutes après sa mise en marche.",
  forgot_link: "Mot de passe oublié ? Cliquez ici",
  forgot_title: "Réinitialiser votre mot de passe",
  forgot_sub: "Saisissez votre e-mail et nous vous enverrons un lien pour réinitialiser votre mot de passe.",
  forgot_submit: "Envoyer le lien",
  forgot_sent: "Si un compte existe pour cet e-mail, nous avons envoyé un lien de réinitialisation. Vérifiez votre boîte de réception.",
  forgot_back: "← Retour à la connexion",
  reset_title: "Définir un nouveau mot de passe",
  reset_sub: "Choisissez un nouveau mot de passe pour votre compte.",
  reset_new_password: "Nouveau mot de passe",
  reset_confirm_password: "Confirmer le mot de passe",
  reset_hint: "Au moins 8 caractères.",
  reset_submit: "Mettre à jour le mot de passe",
  reset_success: "Votre mot de passe a été mis à jour. Redirection vers la connexion…",
  reset_too_short: "Le mot de passe doit comporter au moins 8 caractères.",
  reset_mismatch: "Les mots de passe ne correspondent pas.",
  reset_no_token: "Ce lien de réinitialisation est invalide ou manquant. Demandez-en un nouveau depuis la page de connexion.",
  reset_failed: "Ce lien de réinitialisation est invalide ou a expiré. Demandez-en un nouveau.",
  admin_tab_device_types: "Types d'appareils",
  admin_dt_title: "Types d'appareils",
  admin_dt_sub: "Le catalogue des modèles d'appareils. Renommez le libellé affiché d'un type — la clé interne, la correspondance IoT et la synchronisation ne changent pas.",
  admin_dt_col_label: "Libellé affiché",
  admin_dt_col_key: "Clé interne",
  admin_dt_col_category: "Catégorie",
  admin_dt_col_wearable: "Portable",
  admin_dt_col_ble_sync: "Synchro BLE",
  admin_dt_col_ble_type_id: "ID de type BLE",
  admin_dt_wearable_yes: "Porté par le résident",
  admin_dt_wearable_no: "Fixe",
  admin_dt_ble_sync_on: "Requise",
  admin_dt_ble_sync_off: "Désactivée",
  admin_dt_edit_label: "Modifier le libellé",
  admin_dt_edit_title: "Renommer le libellé",
  admin_dt_edit_desc: "Seul le libellé lisible change. Les appareils, filtres et intégrations continuent d'utiliser la clé interne « {key} ».",
  admin_dt_label_saved: "Libellé mis à jour.",
  admin_dt_label_required: "Le libellé ne peut pas être vide.",
  admin_dt_load_failed: "Charger les types d'appareils",
  admin_dt_save_failed: "Mettre à jour le libellé",
  admin_dt_readonly_hint: "Seuls les super-administrateurs peuvent renommer les libellés.",
  sensor_climate: "Climat",
  sensor_temperature: "Température",
  sensor_humidity: "Humidité",
  sensor_last_reading: "Dernière mesure",
  sensor_history_title: "Température et humidité (48 h)",
  sensor_history_empty_title: "Pas encore de mesures",
  sensor_history_empty_sub: "Attribuez un capteur H4 Pro à cette chambre pour voir l'historique climatique.",
  admin_thresholds_title: "Seuils des capteurs",
  admin_thresholds_desc: "Limites d'alerte de température et d'humidité pour les capteurs H4 Pro de cette organisation.",
  admin_thresholds_temp_min: "Température min",
  admin_thresholds_temp_max: "Température max",
  admin_thresholds_hum_min: "Humidité min",
  admin_thresholds_hum_max: "Humidité max",
  admin_thresholds_temp_invalid: "La température min doit être inférieure à la température max.",
  admin_thresholds_hum_invalid: "L'humidité min doit être inférieure à l'humidité max.",
  admin_thresholds_hint: "Les quatre sont facultatifs — laissez un champ vide pour ne pas alerter sur cette limite.",
  admin_thresholds_cooldown: "Délai entre alertes",
  admin_thresholds_cooldown_placeholder: "Par défaut : 30 min",
  admin_thresholds_cooldown_help: "Minutes entre deux alertes de capteur répétées. Laissez vide pour la valeur système (30 min).",
  admin_thresholds_cooldown_invalid: "Le délai doit être un nombre entier d'au moins 1 minute.",
  admin_thresholds_saved: "Seuils enregistrés.",
  admin_thresholds_load_failed: "Charger les seuils",
  admin_thresholds_save_failed: "Enregistrer les seuils",
  room_activity_view_all: "Voir tous les événements",
  role_super_admin: "Super-administrateur",
  assign_device: "Attribuer un appareil",
  select_device: "Choisir un appareil…",
  admin_patient_no_devices_assigned: "Aucun appareil attribué.",
  admin_patient_no_wearables: "Aucun appareil portable disponible dans cette organisation.",
  admin_patient_device_reassign: "réattribuer",
  recent_critical_alerts_title: "Alertes critiques récentes",
  rooms_building_clear: "Effacer le filtre",
  buildings_title: "Bâtiments",
  buildings_sub: "Chaque bâtiment que vous supervisez, avec ses chambres, résidents et appareils.",
  buildings_view_rooms: "Voir les chambres",
  wt_title: "Tendance de la semaine",
  wt_desc: "Sept nuits côte à côte par résident — ou par chambre partagée — pour repérer les nuits agitées ou inhabituellement calmes.",
  wt_baseline_note: "chaque nuit est comparée à la médiane de 7 nuits de la ligne",
  wt_no_sensors: "Aucun résident n'a encore de capteur de mouvement.",
  wt_flag_restless: "Agitée",
  wt_flag_still: "Inhabituellement calme",
  wt_flag_nodata: "Pas de données",
  wt_flag_silent: "Capteur presque muet",
  rep_sensor_silent: "Le capteur n'a transmis que {pct} % de cette nuit. Les trous indiquent que le capteur a cessé d'émettre, pas que le résident était immobile.",
  wt_legend_active: "Fenêtres de 5 min actives",
  wt_legend_still: "Plus longue immobilité (h)",
  fap_title: "Les familles peuvent traiter les alertes",
  fap_desc: "Activé, les membres de la famille peuvent acquitter, résoudre, rouvrir et annoter les alertes de leurs propres résidents dans {org}.",
  note_saved: "Note enregistrée",
  event_device_silent: "Capteur muet",
  event_no_movement: "Aucun mouvement",
  event_no_rise: "Aucun mouvement après la nuit",

  dur_lt_min: "moins d'une minute",
  dur_min: "{m} min",
  dur_h: "{h} h",
  dur_h_min: "{h} h {m} min",
  am_fall: "Chute détectée",
  am_sos: "Bouton SOS pressé",
  am_low_battery: "Batterie de l'appareil faible",
  am_low_battery_dev: "Batterie faible sur {device}",
  am_door: "Porte ouverte",
  am_door_in: "Porte ouverte dans {place}",
  am_door_in_detail: "Porte ouverte dans {place} ({detail})",
  am_window: "Fenêtre ouverte",
  am_window_in: "Fenêtre ouverte dans {place}",
  am_window_in_detail: "Fenêtre ouverte dans {place} ({detail})",
  am_silent: "Le capteur de mouvement de {place} ne transmet plus depuis environ {dur} — vérifiez son alimentation ou sa passerelle",
  am_silent_nodur: "Le capteur de mouvement de {place} ne transmet plus — vérifiez son alimentation ou sa passerelle",
  am_nomove: "Aucun mouvement détecté dans {place} depuis environ {dur}",
  am_nomove_nodur: "Aucun mouvement détecté dans {place}",
  am_norise: "Aucun mouvement détecté dans {place} depuis la fin de la nuit (levé habituellement avant {time})",
  am_norise_notime: "Aucun mouvement détecté dans {place} depuis la fin de la nuit",
  amf_silent_res: "Le capteur de mouvement de {name} ne transmet plus depuis {time} : les mouvements ne sont pas suivis pour le moment.",
  amf_silent_room: "Le capteur de mouvement de {place} ne transmet plus depuis {time} : les mouvements n'y sont pas suivis pour le moment.",
  amf_sensor_ok: "Le capteur fonctionne ; il n'a simplement vu personne bouger.",
  amf_team: "L'équipe soignante a été alertée sur son tableau de bord.",
  amf_contact_device: "Vous êtes le contact désigné pour cet appareil.",
  amf_contact_resident: "Vous êtes le contact désigné pour {name}.",
  al_tab_care: "Soins",
  al_tab_maint: "Maintenance",
  al_maint_hint: "Capteurs muets et batteries faibles : du travail technique, pas des événements de soin.",
  al_maint_empty: "Aucun problème de capteur ou de batterie.",
  al_auto_closed: "Fermée automatiquement",
  al_auto_closed_reason: "Fermée automatiquement — {reason}",
  al_never_seen: "personne ne l'a vue avant sa fermeture",
  al_resolved_by: "Résolue par {name}",
  al_reason_movement: "le mouvement a repris",
  al_reason_sensor: "le capteur transmet à nouveau",
  al_admin_only_ack: "Seul un administrateur peut traiter cette alerte, car elle n'est liée à aucun résident en particulier.",
  why_title: "Pourquoi cette alerte ?",
  why_since_motion: "Depuis le dernier mouvement",
  why_since_sample: "Depuis la dernière transmission du capteur",
  why_threshold: "Seuil",
  why_up_by: "Levé habituellement avant",
  why_night: "Plage de nuit",
  why_source: "Seuil défini par",
  why_src_org: "cette organisation",
  why_src_default: "les valeurs par défaut",
  why_state: "État du capteur",
  why_checked: "Vérifié à",
  why_approx: "Les vérifications ont lieu toutes les 5 minutes : les heures d'alerte sont approximatives.",
  mon_label: "Suivi des mouvements",
  mon_active: "actif",
  mon_down: "ne transmet pas",
  mon_down_since: "ne transmet plus depuis {time}",
  admin_alerts_up_by_label: "Levé habituellement avant",
  admin_alerts_up_by_question: "Si aucun mouvement n'est vu entre la fin de la nuit et cette heure, une alerte « aucun mouvement depuis la fin de la nuit » est créée.",
  admin_alerts_up_by_invalid: "Doit être après la fin de la nuit ({end}) : c'est l'heure à laquelle les résidents sont habituellement levés, une fois la nuit terminée.",
  admin_alerts_up_by_format: "Saisissez une heure au format HH:MM.",
  admin_alerts_escalation_label: "Prévenir la famille d'un capteur muet après",
  admin_alerts_escalation_question: "L'équipe voit tout de suite un capteur muet. La famille n'est prévenue que s'il n'est toujours pas résolu après ce délai (immédiatement si l'organisation n'a pas de soignants).",
  admin_alerts_cooldown_note: "Après la fermeture d'une alerte, la même alerte peut revenir une fois son seuil de nouveau dépassé. L'alerte du matin se déclenche au plus une fois par jour.",
  admin_alerts_stored_invalid: "L'heure de lever enregistrée ({up}) n'est pas après la fin de la nuit ({end}) : les alertes du matin ne peuvent pas fonctionner et cette politique ne peut pas être enregistrée tant que ce n'est pas corrigé.",
  admin_alerts_defaults_badge: "Valeurs par défaut",

  fap_auto_on: "Automatique : activé, car cette organisation n'a aucun aidant.",
  fap_auto_off: "Automatique : désactivé, car cette organisation a des aidants.",
  fap_manual: "Défini par un administrateur.",
  fap_reset: "Revenir en automatique",
  fap_saved: "Enregistré",
  fap_save_failed: "Impossible d'enregistrer. Réessayez.",
  fap_pending: "Bientôt disponible",
  fap_retry: "Réessayer",
  recap_title: "Récapitulatif matinal de la nuit",
  recap_desc_staff: "Chaque jour à 07:00 (heure de l'organisation), un résumé de la nuit pour chaque résident de votre organisation.",
  recap_desc_family: "Chaque jour à 07:00 (heure de l'organisation), un résumé de la nuit de vos proches.",
  recap_on: "Activé",
  recap_off: "Désactivé",
  recap_email: "E-mail",
  recap_telegram_link_first: "Connectez Telegram ci-dessus pour le recevoir là-bas.",
  recap_no_channel: "Choisissez au moins un canal, sinon rien ne sera envoyé.",
  recap_last_sent: "Dernier envoi {at}",
  recap_saved: "Préférences enregistrées.",
  recap_save_failed: "Impossible d'enregistrer les préférences.",
  recap_unavailable: "Bientôt disponible",
  topbar_org_label: "Organisation",
  device_ota_phase2: "Le déploiement OTA deviendra interactif en phase 2.",
  event_window_open: "Fenêtre ouverte",
  event_window_close: "Fenêtre fermée",
  event_alarm_end: "Fin d'alarme",
  wt_h: "h",
  wt_load_failed: "Impossible de charger l'historique des mouvements. Réessayez plus tard.",
  recap_load_failed: "Impossible de charger les préférences — touchez pour réessayer.",
  mv_shared_note: "Ce résident partage sa chambre. Un capteur de chambre ne distingue pas les résidents : le mouvement est affiché pour la chambre, pas pour une personne.",
  mv_shared_link: "Voir le mouvement de {room}",
  mv_room_shared_note: "Partagée par {n} résidents — ce mouvement ne peut être attribué à aucun d'eux.",
  rep_shared_room_row: "Chambre partagée · {names}",
  admin_motion_resident: "Capteur de chevet d'un résident",
  admin_motion_resident_hint: "Facultatif. Choisissez un résident seulement si ce capteur surveille son espace personnel (p. ex. orienté vers son lit). Ses graphiques de mouvement l'utiliseront, même en chambre partagée.",
  admin_motion_whole_room: "Toute la chambre",
};
export default fr;
